module.exports = __webpack_public_path__ + "static/media/SATTVA.ecbe0c44.png";